import { themr } from '@friendsofreactjs/react-css-themr';
import Link from './Link';

export default themr('Link')(Link);
